
import React, {Component} from 'react';


import {Link, withRouter } from "react-router-dom";
//import auth0Client from '../Auth';

class ReportsMenu extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        questions: null,
        checkingSession: true,
      };
    }
    async componentDidMount() {

       
         
      }
    
    render() {
        return(
           
            <div className="text-center"> 
          <h5> Reports</h5>
            <br/> <br/> <br/>

          
          <div className="row">
              <div className="col-12"  style={{textAlign:'left'}}><h5>FOUND ITEM INVENTORY</h5></div>
          </div>


           
          <div className="row">
            <div className="col-1"><h6>1</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/CurrentInventoryReport"><b>Current Inventory Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Current items in inventory, description and active status</div>
          
          </div>
          <div className="row">
            <div className="col-1"><h6>2</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/CurrentInventoryReportAdvanced"><b>Current Inventory Report-Advanced</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Configurable report on items in inventory marked as unclaimed</div>
          
          </div>

          <div className="row">
            <div className="col-1"><h6>3</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/CurrentInventoryDetailReport"><b>Current Inventory Detail Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Current items in inventory w/ photos, description, active status</div>
          
          </div>
          <div className="row">
            <div className="col-1"><h6>4</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/AgedInventoryReport"><b>Aged Inventory Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Items in inventory, age, description and status</div>
          
          </div>

          <div className="row">
            <div className="col-1"><h6>5</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/FoundersReport"><b>Employee-Found Item(s) Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Report to items in inventory by date with founder id filter and column.  (This report is in Beta)</div>
          
          </div>
          <div className="row">
            <div className="col-1"><h6>6</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/ReleaseDateReport"><b>Release Date Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Inventory Details by Release Date</div>
          
          </div>
          <div className="row">
            <div className="col-1"><h6>7</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/StorageLocationReport"><b>Storage Location Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Items listed by storage location</div>
          
          </div>
        {
          /*
             <div className="row">
              <div className="col-1"><h6>4</h6></div>
              <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link disabled={true} to="/Reports/InventoryReport">** CUSTOM REPORT -(BETA)</Link></p></div>
              <div className="col-6" style={{textAlign:'left'}}>Create a custom report.  Select your fields, date range, and group by columns. (BETA)</div>

            </div>
          */
           


        } 
        <hr/>
          <div className="row">
              <div className="col-12"  style={{textAlign:'left'}}><h5>Claims</h5></div>
          </div>
          <div className="row">
            <div className="col-1"><h6>1</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/ClaimSummaryReport"><b>Claims Summary Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Open claims by date and status. Summary. </div>
          
          </div>

          <div className="row">
            <div className="col-1"><h6>2</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/ClaimDetailReport"><b>Claims Detail Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Claims by date, status, and return method </div>
          
          </div>
          <div className="row">
            <div className="col-1"><h6>3</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/ClaimDetailReportAdvanced"><b>Claims Detail Report-Advanced</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Claims by date, status, and return method </div>
          
          </div>
          
          
        
          <hr/>

        <div className="row">
              <div className="col-12"  style={{textAlign:'left'}}><h5>Shipping</h5></div>
          </div>
           
          

        <div className="row">
            <div className="col-1"><h6>1</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/ShipmentDetailsReport"><b>Shipping Detail Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Shipped items details: Item, state, date,carrier, method and revenue </div>
          
          </div>
          <div className="row">
            <div className="col-1"><h6>1</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/ShippingReportAdvanced"><b>Shipping Detail Report-Advanced</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Shipped Detail Advanced. Fitler, sort, and export shipping records </div>
          
          </div>
          <hr/>
        <div className="row">
        <div className="col-12"  style={{textAlign:'left'}}><h5>Parcel Tracking</h5></div>
        </div>
        <div className="row">
            <div className="col-1"><h6>1</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/PTAgedReport"><b>Parcel Tracking Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Parcels received and stored by age </div>
          
          </div>
          <div className="row">
            <div className="col-1"><h6>2</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/ParcelsAdvanced"><b>Parcels Report-Advanced</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Parcels Report-Advanced. Fitler, sort, and export parcel records </div>
          
          </div>
          
          <hr/>         
          <div className="row">
            <div className="col-12"  style={{textAlign:'left'}}><h5>Audit Tracking</h5></div>
          </div>
        <div className="row">
            <div className="col-1"><h6>1</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/LostItemAuditReport"><b>Changes To Lost &amp; Found</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Display changes made to records for the lost &amp; found by user</div>
          
          </div>

<hr/>
<div className="row">
            <div className="col-12"  style={{textAlign:'left'}}><h5>Disposition Reports</h5></div>
          </div>
          <div className="row">
            <div className="col-1"><h6>1</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/DispositionReport"><b>General Disposition Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Report on found items submitted for disposition</div>
          
          </div>

        <div className="row">
            <div className="col-1"><h6>2</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-success"><Link className="text-info" disabled={true} to="/Reports/VendorDispositionReport"><b>Vendor Recycling Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Report on the status of items submitted to vendors for disposition.</div>
          
          </div>
          
          <hr/>
          <div className="row">
            <div className="col-12"  style={{textAlign:'left'}}><h5>QR Express Reports</h5></div>
          </div>
          <div className="row">
            <div className="col-1"><h6>1</h6></div>
            <div className="col-5" style={{textAlign:'left'}}><p className="text-info"><Link className="text-info" disabled={true} to="/Reports/QRExpressReport"><b>QR Express Import Report</b></Link></p></div>
            <div className="col-6" style={{textAlign:'left'}}>Report on QR Express items and status</div>
          
          </div>

          

          <br/> <br/> <br/> <br/>
       </div>

       
   
        )
       
    }




}


export default withRouter(ReportsMenu);
